import { useNavigate } from 'react-router';
import React, { useEffect, useState } from 'react';
import Content from '../../components/Content';
import Index from '../../components/tags_management/Index';


const TagsManagement = ({ userStore }) => {
  const navigate = useNavigate();
  const [loadingBooks, setLoadingBooks] = useState(true);

  useEffect(() => {
    if (!userStore.isLoggedIn) {
      navigate('/', { replace: true });
      return;
    }
  }, []);

  return (
    <Content title="Livros-Filhos" userStore={userStore}>
      <Index userStore={userStore} />
    </Content>
  );
};

export default TagsManagement;
